import apiago from "../../assets/img/magasin/apiago/apiago1.jpg";
import chalet from "../../assets/img/magasin/chalet/chalet1.jpg";
import essaim from "../../assets/img/magasin/essaim/essaim1.jpg";

import {
  ADD_TO_CART,
  REMOVE_ITEM,
  SUB_QUANTITY,
  ADD_QUANTITY,
  ADD_SHIPPING,
} from "../actions/action-types/cart-actions";

export const initState = {
  items: [
    {
      id: 1,
      title: "La ruche Apiago",
      desc: "L'unique ruche Apiago, vendue avec son essaim d'abeilles noires.",
      price: 2550,
      img: apiago,
      key: "price_1JmZHVKTRoGtcVqMFpEFSETu",
    },
    {
      id: 2,
      title: "Essaim d’abeilles noires",
      desc: "Vendu sur 6 cadres Dadant.",
      price: 169,
      img: essaim,
      key: "price_1ITpW5KTRoGtcVqMq1aOHp8z",
    },
    {
      id: 3,
      title: "La ruche chalet",
      desc: "Ruche Dadant 12 cadres peuplée d’abeilles noires.",
      price: 800,
      img: chalet,
      key: "price_1ITpVSKTRoGtcVqMomyHzxS5",
    },
    {
      id: 4,
      title: "[Acompte de réservation] La ruche Apiago",
      desc: "Précommande de la ruche Apiago, vendue avec son essaim d'abeilles noires.",
      price: 995,
      img: apiago,
      key: "price_1JmZqnKTRoGtcVqM41Jpb1LM",
    },
    {
      id: 5,
      title: "Kit support fixation isolation extérieure",
      desc: "Kit de fixation spécifique sur façade isolée par l’extérieur.",
      price: 85,
      key: "price_1IQZsAKTRoGtcVqMdLS7555a",
    },
  ],
  addedItems: [],
  total: 0,
};

const cartReducer = (state = initState, action) => {
  //INSIDE HOME COMPONENT
  if (action.type === ADD_TO_CART) {
    let addedItem = state.items.find((item) => item.id === action.id);
    //check if the action id exists in the addedItems
    let existed_item = state.addedItems.find((item) => action.id === item.id);
    if (existed_item) {
      addedItem.quantity += 1;
      return {
        ...state,
        total: state.total + addedItem.price,
      };
    } else {
      addedItem.quantity = 1;
      //calculating the total
      let newTotal = state.total + addedItem.price;

      return {
        ...state,
        addedItems: [...state.addedItems, addedItem],
        total: newTotal,
      };
    }
  }
  if (action.type === REMOVE_ITEM) {
    let itemToRemove = state.addedItems.find((item) => action.id === item.id);
    let new_items = state.addedItems.filter((item) => action.id !== item.id);

    //calculating the total
    let newTotal = state.total - itemToRemove.price * itemToRemove.quantity;
    console.log(itemToRemove);
    return {
      ...state,
      addedItems: new_items,
      total: newTotal,
    };
  }
  //INSIDE CART COMPONENT
  if (action.type === ADD_QUANTITY) {
    let addedItem = state.items.find((item) => item.id === action.id);
    addedItem.quantity += 1;
    let newTotal = state.total + addedItem.price;
    return {
      ...state,
      total: newTotal,
    };
  }
  if (action.type === SUB_QUANTITY) {
    let addedItem = state.items.find((item) => item.id === action.id);
    //if the qt == 0 then it should be removed
    if (addedItem.quantity === 1) {
      let new_items = state.addedItems.filter((item) => item.id !== action.id);
      let newTotal = state.total - addedItem.price;
      return {
        ...state,
        addedItems: new_items,
        total: newTotal,
      };
    } else {
      addedItem.quantity -= 1;
      let newTotal = state.total - addedItem.price;
      return {
        ...state,
        total: newTotal,
      };
    }
  }

  if (action.type === ADD_SHIPPING) {
    return {
      ...state,
      total: state.total + 6,
    };
  }

  if (action.type === "SUB_SHIPPING") {
    return {
      ...state,
      total: state.total - 6,
    };
  } else {
    return state;
  }
};

export default cartReducer;
